import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { 
  Grid,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import DispositivoContext from "context/dispositivo/dispositivoContext";
import VariableContext from "context/variable/variableContext";
import AuthContext from "context/autentication/authContext";
import AlertaContext from "context/alertas/alertaContext";
import SubGrupoContext from "context/subgrupo/subgrupoContext";
import UsuarioContext from "context/usuario/usuarioContext";
import AlertasDispositivoContext from "context/alertas-dispositivo/alertasDispositivoContext";

import { VarName } from "types/variable";

import SelectorVariable from "components/Selector/SelectorVariable";
import SelectorDispositivos from "components/Selector/SelectorDispositivos";
import SelectorSilobolsa from "components/Selector/SelectorSilobolsa";
import BotonLoading from "components/Buttons/BotonLoading";
import MensajeAlerta from "components/MensajeAlerta";

import ShowResponse from "./ShowResponse";
import HelpInput from "./HelpInput";

////////// estilos ///////////////
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "85vh",
    width: "98%",
    marginRight: "5em",
    flexGrow: 1,
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  text: {
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  form: {
    minHeight: "100%",
    width: "98%",
    flexGrow: 1,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  error: {
    color: "red",
  },
}));

export default function EditarDispositivo({ setOpen, init, update }) {
  ////////// estilos ///////////////
  const classes = useStyles();
  ///////////////// variables ////////////////
  const usuarioContext = useContext(UsuarioContext);
  const { obtenerUsuariosRol } = usuarioContext;
  const variableContext = useContext(VariableContext);
  const {
    variables,
    obtenerVariables,
    mensaje,
    clearErrorVariable,
    clearOkVariable,
  } = variableContext;

  const authContext = useContext(AuthContext);
  const { cliente } = authContext;

  const dispositivoContext = useContext(DispositivoContext);
  const {
    dispositivos,
    obtenerDispositivos,
  } = dispositivoContext;

  const alertasDispositivoContext = useContext(AlertasDispositivoContext);
  const {
    crearAlertaDispositivo
  } = alertasDispositivoContext;

  const [state, setState] = useState();
  const [mail, setMail] = useState(false);
  const [dispositivoElegido, setDispositivoElegido] = useState();
  const [variableElegida, setVariableElegida] = useState();
  const [statePolicia, setStatePolicia] = useState();
  const [callback, setCallback] = useState({ msg: "", request: "" });

  // extraer los valores del context
  const alertaContext = useContext(AlertaContext);
  const { alerta, mostrarAlerta } = alertaContext;
  const [listaSupervisores, setListaSupervisores] = useState([]);
  const [defaultMSG, setDefaultMSG] = useState("");

  ////////// funciones ///////////////
  useEffect(() => {
    if (mensaje) {
      mostrarAlerta(mensaje.msg, mensaje.categoria);
      // limpio el msj
      clearErrorVariable();
      clearOkVariable();
    }
    // eslint-disable-next-line
  }, [mensaje]);

  const fetchData = async () => {
    await obtenerDispositivos(cliente);
    const supervisores = await obtenerUsuariosRol("SUPERVISOR")
    if (supervisores != null) {
      armarListaSupervisores(supervisores)
    }
  }

  useEffect(() => {
    setState({ supervisada: "", mensajeAlerta: "" });
    setDispositivoElegido();
    fetchData()
    // eslint-disable-next-line
  }, []);

  const armarListaSupervisores = (x) => {
    let data = x.map((us) => {
      if (us?.usuario) {
        return {
          nombre: us.usuario.nombre,
          id: us.usuario.id,
        }
      }
    });
    setListaSupervisores(data);
  };

  const getSubG = (x) => {
    setCallback({ msg: "", request: "" });

    if (x) {
      obtenerVariables({ dispositivoId: x.id });
      setDefaultMSG(`Usted posee una alerta del dispositivo ${x.nombre}.`)
      setState({ ...state, nombreDispositivo: x.nombre });
      setVariableElegida();
    }
  };

  const handleSupervision = (e) => {
    setState({
      ...state,
      supervisada: e.target.value,

    });
    setStatePolicia("");
  };

  const handleComparacion = (e) => {
    setState({
      ...state,
      tipoComparacion: e.target.value,
    });
  };

  const handleMovimiento = (e) => {
    setState({
      ...state,
      valorComparacion: e.target.value,
    });
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleChangePolicia = (event) => {
    setStatePolicia({
      id: event.target.value.id,
      nombre: event.target.value.nombre,
    });
  };

  const onChange = (e) => {
    setCallback({ msg: "", request: "" });
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeMSG = (e) => {
    setState({
      ...state,
      mensajeAlerta: e.target.value,
    });
  };

  const onSubmit = () => {
    let toSave;
    // Validar que no haya campos vacios
    if (state.supervisada === "NO" && !state.enviaMail && !state.enviaSMS) {
      setCallback({
        ...callback,
        msg: "*Debe poseer al menos un nivel de supervisión",
      });
    } else if (
      (!state.tipoComparacion || !state.valorComparacion) &&
      state.referenciaNodo !== VarName.Movimiento
    ) {
      setCallback({
        ...callback,
        msg: "*Debe elegir que valores supervisar",
      });
    } else {
      setCallback({
        ...callback,
        msg: "",
      });
      toSave = state;
      if (toSave.supervisada === "POLICIAL" || toSave.supervisada === "NO") {
        toSave.enviaSMS = false;
        toSave.enviaMail = false;
      }
      if (state.referenciaNodo === VarName.Movimiento) {
        toSave.tipoComparacion = "=";
      }
      if (toSave.enviaMail || toSave.enviaSMS) {
        if (!toSave.mensajeAlerta) {
          toSave.mensajeAlerta = defaultMSG;
        }
      }
      toSave.usuarioSupervisor = statePolicia?.id;
      toSave.dispositivoId = state.dispositivoId;
      crearAlertaDispositivo(toSave)/* .then((value) => setCallback(value)); */
    }
    setOpen(false);
    init();
  };
  //{'=':'=', '>=':'>=', '>':'>', '!=':'!=', '<':'<', '<=':'<='}
  const comparacionArray = ["=", ">=", ">", "!=", "<", "<="];

  const comparacionATexto = (x) => {
    switch (x) {
      case "=":
        return "Igual a ";
        break;
      case ">=":
        return "Mayor o igual a ";
        break;
      case ">":
        return "Mayor a ";
        break;
      case "!=":
        return "Distinto a ";
        break;
      case "<":
        return "Menor a ";
        break;
      case "<=":
        return "Menor o igual a ";
        break;
      default:
        return " ";
        break;
    }
  };
  
  const elegirVariable = (x) => {
    const variable = {
      ...x,
      nombreDispositivo: state.nombreDispositivo,
      mensajeAlerta: state.mensajeAlerta || defaultMSG,
      variableDispositivoId: x?.id
    }
    setVariableElegida(variable);
    setState(variable);
  };
  //// logica para ver si el dispositivo es silobolsa
  // TODO: ver si se puede hacer una funcion para esto
  const [silobolsa, setSilobolsa] = useState(false);
  
  //???? 
  const esSiloBolsa = (dispositivo) => {
    return false;
    setSilobolsa(
      dispositivo.modelo.nombre === "SB-100" ||
      dispositivo.modelo.nombre === "SB-101" ||
      dispositivo.modelo.nombre === "FIELD L-Silo" ||
      dispositivo.modelo.nombre === "L-Move" ||
      dispositivo.modelo.nombre === "L-Silo"
    );
  };

  useEffect(() => {
    if (dispositivoElegido) {
      esSiloBolsa(dispositivoElegido);
    }
  }, [dispositivoElegido]);

  const handleSilobolsa = (variable) => {
    let tempVar = variable;
    if (variable) {
      if (tempVar.referenciaNodo === VarName.Movimiento) {
        tempVar["valorComparacion"] = 1;
        tempVar["tipoComparacion"] = "=";
      }
      if (tempVar.referenciaNodo === VarName.Bateria) {
        tempVar["valorComparacion"] = 20;
        tempVar["tipoComparacion"] = "<=";
      }
    }
    setVariableElegida(tempVar);
    setState(tempVar);
  };

  return (
    <Grid
      container
      direction="row-reverse"
      justify="center"
      alignItems="start"
      spacing={1}
      style={{ width: "800px" }}
    >
      {alerta ? (
        alerta.categoria !== "error" ? (
          <>
            <MensajeAlerta categoria={alerta.categoria} mensaje={alerta.msg} />
          </>
        ) : null
      ) : null}
      <Grid item xs={12} md={12} lg={12}>
        {
          state &&
          <div noValidate autoComplete="off" onSubmit={onSubmit}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item xs={11} md={5} lg={5}>
                {dispositivos && (
                  <SelectorDispositivos
                    grupos={dispositivos}
                    func={setDispositivoElegido}
                    subG={getSubG}
                  />
                )}
              </Grid>
              <Grid
                item
                xs={1}
                md={1}
                lg={1}
                style={{ marginLeft: "-5px", padding: "0px" }}
              >
                <HelpInput help={"Seleccione el dispositivo a controlar"} />
              </Grid>
              <Grid item xs={11} md={5} lg={5}>
                {dispositivoElegido ? (
                  !silobolsa ? (
                    <SelectorVariable
                      grupos={dispositivos}
                      elegido={dispositivoElegido}
                      subGrupos={variables}
                      func={elegirVariable}
                    />
                  ) : (
                    <SelectorSilobolsa
                      dispositivos={dispositivos}
                      dispositivoElegido={dispositivoElegido}
                      variables={variables}
                      func={handleSilobolsa}
                    />
                  )
                ) : (
                  <SelectorVariable />
                )}
              </Grid>
              <Grid
                item
                xs={1}
                md={1}
                lg={1}
                style={{ marginLeft: "-5px", padding: "0px" }}
              >
                <HelpInput
                  help={
                    "Ayuda Seleccione cual de las variables desea controlar"
                  }
                />
              </Grid>
              <Grid item xs={11} md={5} lg={5}>
                {variableElegida ? (
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="supervisada">Supervisión</InputLabel>
                    {variableElegida?.supervisada === "COMPARTIDA" || variableElegida?.supervisada === "POLICIAL" ?
                      <Select
                        labelId="supervisada"
                        id="supervisada"
                        value={state.supervisada}
                        onChange={handleSupervision}
                        label="supervisada"
                      >
                        <MenuItem value="LOCAL">
                          Notificaciones al usuario
                        </MenuItem>
                        {/* <MenuItem value="POLICIAL">
                          Notificaciones a la policia
                        </MenuItem>
                        <MenuItem value="COMPARTIDA">
                          Ambas notificaciones
                        </MenuItem> */}
                      </Select>
                      :
                      <Select
                        labelId="supervisada"
                        id="supervisada"
                        value={state.supervisada}
                        onChange={handleSupervision}
                        label="supervisada"
                      >
                        <MenuItem value="LOCAL">
                          Notificaciones al usuario
                        </MenuItem>
                      </Select>
                    }

                  </FormControl>
                ) : (
                  <FormControl variant="outlined" fullWidth disabled>
                    <InputLabel id="supervisada">Supervisión</InputLabel>
                    <Select
                      labelId="supervisada"
                      id="supervisada"
                      value={state.supervisada}
                      label="supervisada"
                    >
                      <MenuItem value="LOCAL">
                        Notificaciones al usuario
                      </MenuItem>
                      {/* <MenuItem value="POLICIAL">
                        Notificaciones a la policia
                      </MenuItem>
                      <MenuItem value="COMPARTIDA">
                        Ambas notificaciones
                      </MenuItem> */}
                    </Select>
                  </FormControl>
                )}
              </Grid>
              <Grid
                item
                xs={1}
                md={1}
                lg={1}
                style={{ marginLeft: "-5px", padding: "0px" }}
              >
                <HelpInput
                  help={
                    "Seleccione a quien desea notificar cuando este en alerta"
                  }
                />
              </Grid>
              {state.supervisada ? (
                <>
                  {state.referenciaNodo !== VarName.Movimiento && !silobolsa && (
                    <Grid item xs={11} md={3} lg={3}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel id="supervisada">Cuando sea</InputLabel>
                        <Select
                          labelId="tipoComparacion"
                          id="tipoComparacion"
                          value={state.tipoComparacion}
                          onChange={handleComparacion}
                          label="tipoComparacion"
                        >
                          {comparacionArray.map((x, index) => {
                            return (
                              <MenuItem key={index} value={x}>
                                {comparacionATexto(x)}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                  {state.referenciaNodo !== VarName.Movimiento && !silobolsa ? (
                    <Grid item xs={11} md={2} lg={2}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="valorComparacion"
                        name="valorComparacion"
                        label={"Valor"}
                        value={state.valorComparacion}
                        onChange={onChange}
                      />
                    </Grid>
                  ) : !silobolsa ? (
                    <Grid item xs={11} md={5} lg={5}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel id="supervisada">Cuando</InputLabel>
                        <Select
                          labelId="tipoComparacion"
                          id="tipoComparacion"
                          value={state.valorComparacion}
                          onChange={handleMovimiento}
                          label="tipoComparacion"
                        >
                          <MenuItem value="1">Detecta movimiento</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  ) : null}
                  {!silobolsa && (
                    <Grid
                      item
                      xs={1}
                      md={1}
                      lg={1}
                      style={{ marginLeft: "-5px", padding: "0px" }}
                    >
                      <HelpInput help={"Ayuda Numero a definir"} />
                    </Grid>
                  )}
                </>
              ) : (
                <>
                  <Grid item xs={11} md={5} lg={5}>
                    <FormControl variant="outlined" fullWidth disabled>
                      <InputLabel id="supervisada">Cuando</InputLabel>
                      <Select
                        labelId="tipoComparacion"
                        id="tipoComparacion"
                        disabled
                        label="tipoComparacion"
                      >
                        <MenuItem value="1">Detecta movimiento</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    md={1}
                    lg={1}
                    style={{ marginLeft: "-5px", padding: "0px" }}
                  >
                    <HelpInput help={"Ayuda Numero a definir"} />
                  </Grid>
                </>
              )}
              <Grid item xs={11} md={5} lg={5} pl={1}>

                {(state.valorComparacion && variableElegida?.supervisada !== "LOCAL" && state?.supervisada !== "LOCAL") &&
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="DistritoPolicial">
                      Distrito Policial
                    </InputLabel>
                    <Select
                      labelId="DistritoPolicial"
                      id="DistritoPolicial"
                      value={statePolicia?.nombre}
                      onChange={handleChangePolicia}
                      label="DistritoPolicial"
                    >
                      {listaSupervisores.length === 0 ? (
                        <MenuItem value="">
                          <em>No posee distritos registrados</em>
                        </MenuItem>
                      ) : (
                        listaSupervisores.map((p) => (
                          <MenuItem value={p}>{p.nombre}</MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                }
              </Grid>
              <Grid item xs={1} md={1} lg={1}>
                <></>
              </Grid>
              <Grid item xs={11} md={5} lg={5}>
                <Grid item xs={7}>
                  <h5
                    style={{
                      paddingBottom: "0px",
                      marginBottom: "0px",
                      marginTop: "0px",
                      textAlign: "center",
                    }}
                  >
                    Entrega de alertas
                  </h5>
                </Grid>
                {state.supervisada === "LOCAL" ||
                  state.supervisada === "COMPARTIDA" ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        direction: "row",
                        justifyContent: "center",
                      }}
                    >
                      <Grid item xs={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={state.enviaMail}
                              onChange={handleChange}
                              name="enviaMail"
                              color="primary"
                            />
                          }
                          label="eMail"
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={state.enviaSMS}
                              onChange={handleChange}
                              name="enviaSMS"
                              color="primary"
                            />
                          }
                          label="SMS"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        md={1}
                        lg={1}
                        style={{ marginLeft: "-5px", padding: "0px" }}
                      >
                        <HelpInput
                          help={
                            "Seleccione si desea recibir notificaciones via email o sms ademas de las notificaciones de la web"
                          }
                        />
                      </Grid>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        direction: "row",
                        justifyContent: "center",
                      }}
                    >
                      <Grid item xs={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled
                              checked={mail}
                              name="enviaMail"
                              color="primary"
                            />
                          }
                          label="eMail"
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled
                              checked={mail}
                              name="enviaSMS"
                              color="primary"
                            />
                          }
                          label="SMS"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        md={1}
                        lg={1}
                        style={{ marginLeft: "-5px", padding: "0px" }}
                      >
                        <HelpInput
                          help={
                            "Seleccione si desea recibir notificaciones via email o sms ademas de las notificaciones de la web"
                          }
                        />
                      </Grid>
                    </div>
                  </>
                )}
              </Grid>
              <Grid item xs={1} md={1} lg={1}>
                <></>
              </Grid>
              <Grid item xs={11}>
                {state.supervisada === "LOCAL" ||
                  state.supervisada === "COMPARTIDA" ? (
                  <Grid item xs={11}>
                    <TextField
                      id="outlined-multiline-static"
                      label="Mensaje de alerta*"
                      multiline
                      fullWidth
                      rows={2}
                      value={state.mensajeAlerta}
                      onChange={onChangeMSG}
                      defaultValue={defaultMSG}
                      variant="outlined"
                    />
                  </Grid>
                ) : (
                  <Grid item xs={11}>
                    <TextField
                      disabled
                      id="outlined-multiline-static"
                      label="Mensaje de alerta*"
                      multiline
                      fullWidth
                      rows={2}
                      defaultValue={defaultMSG}
                      variant="outlined"
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="start"
              spacing={0}
            >
              <ShowResponse callback={callback} />
            </Grid>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="start"
              spacing={3}
            >
              <Grid item xs={4}>
                {!variableElegida ||
                  !state.valorComparacion ||
                  state.supervisada === "NO" ? (
                  <BotonLoading
                    texto={"Guardar"}
                    disabled={true}
                    load={alerta}
                    onClick={onSubmit}
                  />
                ) : (
                  <BotonLoading
                    texto={"Guardar"}
                    disabled={false}
                    load={alerta}
                    onClick={onSubmit}
                  />
                )}
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          </div>

        }
      </Grid>
    </Grid>
  );
}
